import { render } from "./SectionWelcome.vue?vue&type=template&id=29f6cfe6&scoped=true"
import script from "./SectionWelcome.vue?vue&type=script&lang=js"
export * from "./SectionWelcome.vue?vue&type=script&lang=js"

import "./SectionWelcome.vue?vue&type=style&index=0&id=29f6cfe6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f6cfe6"]])

export default __exports__